
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M19.135 4.268L6.036 16.992l13.268 12.891v.001c.434.436.701 1.031.701 1.685 0 1.341-1.12 2.428-2.499 2.428a2.53 2.53 0 01-1.735-.681l-.001.001L.771 18.746v-.002a2.382 2.382 0 01-.765-1.746v-.006-.006c0-.686.293-1.305.765-1.747L15.77.667l.006.006a2.53 2.53 0 011.73-.675c1.379 0 2.499 1.087 2.499 2.428 0 .737-.338 1.397-.87 1.842z"}})])
          )
        }
      }
    